import {useSources} from "./getSources";
import {useVideo} from "./useVideo";
import {useVpaid} from "./useVpaid";
import {useSelector} from "react-redux";
import {AppState} from "../../state";
import equals from "fast-deep-equal";

const useVast = () => {

    const { source } = useSelector((state: AppState)=>({ source: state.source }), equals);
    const sources = useSources(source);
    const vpaid = useVpaid(sources);
    const video = useVideo(sources );
    return video || vpaid || false;
}

export default useVast;